import {
  PRODUCTION_HOSTNAMES,
  STAGING_HOSTNAMES,
} from 'src/utils/environmentHosts'

import FavIconDev from '../images/favicon-dev.png'
import FavIconProd from '../images/favicon-prod.png'
import FavIconStaging from '../images/favicon-staging.png'

// Per-environment favicon so prod / staging / dev browser tabs are visually
// distinguishable (blue / amber / grey).
//
// The hostname lists moved to `src/utils/environmentHosts` when the design
// toggle needed the same "is this production?" answer; that module carries the
// reasoning for keying on hostname rather than REACT_APP_ENVIRONMENT, and the
// verified host list. This file is one of two consumers.
export const resolveEnvFavicon = (): string => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''

  if (PRODUCTION_HOSTNAMES.includes(hostname)) return FavIconProd
  if (STAGING_HOSTNAMES.includes(hostname)) return FavIconStaging
  return FavIconDev
}
